module.exports = "M6,5V5.18L8.82,8H11.22L10.5,9.68L12.6,11.78L14.21,8H20V5H6M3.27,5L2,6.27L8.97,13.24L6.5,19H9.5L11.07,15.34L16.73,21L18,19.73L3.55,5.27L3.27,5Z"


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-design-icons-svg/paths/format-clear.json
// module id = 422
// module chunks = 0